<template>
    <div class="flex w-full">
        <div class="hidden tablet:flex justify-center items-center w-24 pl-4">
            <input
                v-if="theme === 'themeAlt'"
                :checked="selected"
                type="radio"
                class="w-6 h-6 border-solid border-2 border-blue"
            >
            <img
                v-else
                alt=""
                class="object-contain"
                :src="theme === 'themeSalmon' ? answer.imageAlt : answer.image"
            />
        </div>
        <div
            :class="theme !== 'themeAlt' ? 'tablet:px-5 py-5 tablet:pl-10' : 'py-3'"
            class="px-4 tablet:px-2 w-full tablet:w-9/12 text-center tablet:text-left overflow-hidden self-center"
        >
            <h3 class="text-lg font-semibold" :class="theme == 'themeAlt' ? 'text-navy-dark' : ''">
                {{ answer.headingAlt }}
                <span class="text-lg font-normal">
                    {{ answer.descriptorAlt }}
                </span>
            </h3>
            <p class="text-sm text-navy-dark whitespace-nowrap overflow-hidden overflow-ellipsis tablet:pr-10">
                {{ answer.subheadingAlt }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QuizItem',
    props: {
        answer: {
            type: Object,
            default: {},
        },
        theme: {
            type: String,
            default: '',
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
}
</script>